<template>
  <form
    v-if="isWsReady"
    :class="classes"
    @submit.prevent="handleSendMessage"
  >
    <div class="chat-input-wrapper">
      <label for="honeypot" class="chat-input-h">
        {{ $t('chatbot.honeypot') }}
      </label>
      <input
        id="honeypot"
        v-model="honeypot"
        class="chat-input-h"
        aria-hidden="true"
        tabindex="-1"
      >
      <label for="chatInput" class="chat-input-label">
        {{ placeholder }}
      </label>
      <auto-height-input
        id="chatInput"
        v-model="textMessage"
        :disabled="!isChatInputEnabled"
        :type="inputType"
        :name="inputName"
        :autocomplete="autoComplete"
        :placeholder="placeholder"
        @submit="handleSendMessage"
        @invalid="handleFormInvalid"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>

    <button
      id="sendButton"
      type="submit"
      class="send-button"
      :aria-label="$t('chatbot.send')"
      :disabled="!isChatInputEnabled"
    >
      <button-icon />
    </button>
  </form>
</template>

<script>
// @flow

import { mapState, mapGetters } from 'vuex'

import { formatDate } from '../../../common/utils/date'
import { CHATBOT_EVENTS, dispatchChatchampEvent } from '../../../main/eventTracking'

import { isRequestInputMessage } from '../../models'
import { sendTextMessage } from '../../utils/api'

import AutoHeightInput from './AutoHeightInput.vue'
import ButtonIcon from './ButtonIcon.vue'

export default {
  components: {
    AutoHeightInput,
    ButtonIcon
  },
  data () {
    return {
      textMessage: '',
      honeypot: '',
      isFocused: false
    }
  },
  computed: {
    ...mapState(['isWsReady']),
    ...mapGetters(['isChatInputEnabled', 'latestMessage']),
    inputType (): string {
      return this.latestMessage?.content?.type || 'text'
    },
    inputName (): string {
      return (this.latestMessage?.content?.placeholder || 'text')
        .toLowerCase()
        .replace(/\s+/g, '')
    },
    autoComplete (): string {
      if (this.inputType === 'text') {
        return 'on'
      } else {
        return this.inputType
      }
    },
    placeholder () {
      if (this.isChatInputEnabled) {
        if (isRequestInputMessage(this.latestMessage)) {
          if (this.inputType === 'date') return 'YYYY-MM-DD'
          if (this.latestMessage.content.placeholder === 'customerServiceInputPlaceholder') return this.$t('chatbot.customerServiceInputPlaceholder')
          return this.latestMessage.content.placeholder || 'Your reply'
        }

        return 'Send a message...'
      }

      return 'Choose your option...'
    },
    classes () {
      return {
        'chat-input-form': true,
        'chat-input-form--is-focused': this.isFocused
      }
    }
  },
  methods: {
    handleSendMessage (e: any) {
      e.preventDefault()

      if (this.honeypot) return

      let text = this.textMessage.trim()

      if (text && text.length > 0) {
        const { attribute } = this.latestMessage.content
        if (this.inputType === 'date') text = formatDate(text)
        sendTextMessage(text, this.latestMessage.content.messageId, this.latestMessage.content.streamInput)
        this.$store.dispatch('addTextMessageToList', text)
        this.textMessage = ''
        if (attribute) dispatchChatchampEvent(CHATBOT_EVENTS.AttributeSet, { ...attribute, value: text })
      }
    },
    handleFormInvalid (e: any) {
      switch (this.inputType) {
        case 'email':
          e.target.setCustomValidity('Must be valid email address.')
          break
        default:
          break
      }
    },
    handleFocus () {
      this.isFocused = true
    },
    handleBlur () {
      this.isFocused = false
    }
  }
}
</script>

<style src="./chat-input.scss" />
